<template>
  <dialogBar @on-close="close" v-if="config.show" :dialog-width="config.width">
    <div slot="header">{{config.title}}</div>
    <div class="dialog_publish_main" slot="main">
      <el-tree
        v-if="config.menuTree"
        ref="resourceTree"
        :data="config.menuTree"
        show-checkbox
        highlight-current
        :render-content="renderContent"
        clearable
        node-key="id"
        :props="defaultProps"
      ></el-tree>
    </div>
    <div slot="footer">
      <el-button type="info" size="mini" @click="close(false)">取消</el-button>
      <el-button type="primary" size="mini" @click="onSubmit()">确认</el-button>
    </div>
  </dialogBar>
</template>
<script>
import dialogBar from "./comment/dialogBar";
import * as sysApi from "../../services/sys";

export default {
  components: {
    dialogBar: dialogBar
  },
  props: {
    config: {
      type: Object,
      default: {
        show: false,
        width: 800,
        title: "",
        data: {},
        menuTree: []
      }
    }
  },
  data() {
    return {
      roleid : '',
      defaultProps: {
        children: "children",
        label: "name",
        id: "id"
      },
      rules: {}
    };
  },
  methods: {
    renderContent(h, { node, data, store }) {
      return (
        <span>
          <span>
            <span>
              <i class={data.icon}></i>&nbsp;{node.label}
            </span>
          </span>
        </span>
      );
    },
    close(result) {
      this.config.show = false;
      if (result) this.$emit("close");
    },
    onSubmit() {
      let _this = this
      var checkedKeys = this.$refs.resourceTree.getCheckedKeys()
      var halfCheckedKeys = this.$refs.resourceTree.getHalfCheckedKeys()
      var parmes = {
        RoleId: this.roleid,
        AppCode: process.env.VUE_APP_CODE,
        ModuleIds: checkedKeys,
        HalfModuleIds: halfCheckedKeys
      }
      sysApi.SetRoleMappingModule(parmes).then(res => {
        // _this.$refs.resourceTree.setCheckedKeys(res);
        _this.$message("权限设置，保存成功");
        _this.close(true)
      });
    },
    loadRoleModuleMapping(id) {
      this.roleid = id
      let _this = this
      sysApi.roleModuleMappingList(id).then(res => {
        _this.$refs.resourceTree.setCheckedKeys(res);
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog_publish_main {
  padding-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/dialog/RoleModuleMapping.vue